import React, { Component, Fragment } from "react";
import CardInformasiPinjaman from "../../organism/pinjaman/CardInformasiPinjaman";
import CardData from "../../organism/pinjaman/StatusPinjaman/CardData";
import CheckAuth from "../../../utils/hoc/CheckAuth";
import { connect } from "react-redux";
import { LoanDetail, GetVA } from "../../../redux/actions/LoanDetail";
import Loading from "../../../components/molecules/Loading";
import LoanGrade from "../../../utils/actions/GetParameter";
import { SET_ERROR_STATE } from "../../../utils/constants/actionTypes";
import { GLoanGrade } from "../../../config/api";
import ModalCaraTF from "../../organism/ModalCaraTF";
import ButtonTTD from "../../organism/ButtonTTD";

let statusRincianPembayaran = ["DS1", "WD1"];

class StatusPinjamanDetil extends Component {
	_isMounted = false;
	constructor(props) {
		super(props);
		this.state = {
			pembayaran: true,
			statusBtn: [
				{ title: "Data Pinjaman", status: true, key: "DataPinjaman" },
				{ title: "Informasi Dokumen", status: false, key: "InformasiDokumen" },
				/*{ title: "Data Jaminan", status: false, key: "DataJaminan" },*/
				{ title: "Riwayat Negosiasi", status: false, key: "RiwayatNegosiasi" },
				{ title: "Riwayat Status", status: false, key: "RiwayatStatus" },
				{ title: "Riwayat Memo", status: false, key: "RiwayatMemo" },
			],
			statusBtnRincian: [
				{ title: "Rincian Pembayaran", status: true, key: "RincianPembayaran" },
				{ title: "Data Pinjaman", status: false, key: "DataPinjaman" },
				{ title: "Informasi Dokumen", status: false, key: "InformasiDokumen" },
				/*{ title: "Data Jaminan", status: false, key: "DataJaminan" },*/
				{ title: "Riwayat Negosiasi", status: false, key: "RiwayatNegosiasi" },
				{ title: "Riwayat Status", status: false, key: "RiwayatStatus" },
				{ title: "Riwayat Memo", status: false, key: "RiwayatMemo" },
			],
			LoanGrade: [],
			show: false,
		};
	}

	componentDidMount = () => {
		this._isMounted = true;
		let { loanCode } = this.props.match.params;
		let urlPath = window.location.pathname;
		console.log({ urlPath });

		LoanGrade(GLoanGrade, null, (data, err) => {
			if (err) {
				this.props.SetError(err);
			} else {
				if (this._isMounted) {
					this.setState({ LoanGrade: data.loan.grades });
				}
			}
		});
		this.props.setTitlePage({
			title: "Pinjaman Detil",
			breadcrumb: [
				{ name: "Beranda", url: "/dashboard", status: false },
				{ name: "Pinjaman Detil", url: urlPath, status: false },
				{ name: loanCode, url: urlPath, status: true },
			],
		});
		this.setData();
	};

	componentWillUnmount = () => {
		this._isMounted = false;
	};

	setData = () => {
		let { loanCode } = this.props.match.params;
		if (this.props.ClientID !== null) {
			this.props.getLoanDetail(this.props.ClientID, loanCode);
		}
	};

	changeBtn = (index) => {
		let { detail } = this.props.loanDetail;

		let statusBtn = statusRincianPembayaran.indexOf(detail.loanStatus) === -1 ? this.state.statusBtn : this.state.statusBtnRincian;
		for (let i = 0; i < statusBtn.length; i++) {
			if (i === index) {
				statusBtn[i].status = true;
			} else {
				statusBtn[i].status = false;
			}
		}
		this.setState({ statusBtn });
	};

	render() {
		let { loanCode } = this.props.match.params;
		let { statusBtn, dataDetail, LoanGrade, statusBtnRincian, show } = this.state;
		let { detail, loading, errorMessage } = this.props.loanDetail;

		return (
			<div>
				{detail && (
					<div className="row">
						<div className="col-md-4" style={{ padding: "0px 25px" }}>
							<CardInformasiPinjaman data={detail} openCaraTF={() => this.setState({ show: true })} />
						</div>
						<div className="col-md-8" style={{ padding: "0px 25px" }}>
							<CardData history={this.props.history} statusBtn={statusRincianPembayaran.indexOf(detail.loanStatus) === -1 ? statusBtn : statusBtnRincian} changeBtn={this.changeBtn} dataDetail={detail} LoanGrade={LoanGrade} />
						</div>
					</div>
				)}
				{loading && <Loading />}
				<ModalCaraTF
					show={show}
					title={"Metode Top Up melalui ATM Bank Lain"}
					content={
						<div>
							<p className={"text-left my-3"}>1. Masukkan kartu ATM ke mesin ATM.</p>
							<p className={"text-left my-3"}>2. Masukkan PIN Anda</p>
							<p className={"text-left my-3"}>3. Pilih menu "Transfer antar bank" atau "Transfer online antar bank"</p>
							<p className={"text-left my-3"}>4. Masukkan kode bank BNI(009) atau pilih bank yang dituju yaitu BNI.</p>
							<p className={"text-left my-3"}>5. Masukkan nomor Virtual Account {detail && detail.virtualAccount && detail.virtualAccount.virtualAccountNumber} milik Anda pada kolom rekening tujuan.</p>
							<p className={"text-left my-3"}>6. Masukkan nominal uang yang akan ditransfer.</p>
							<p className={"text-left my-3"}>7. Konfirmasi rincian Anda akan tampil dilayar, cek dan apabila sudah selesai silahkan lanjutkan transaksi Anda hingga selesai.</p>
							<p className={"text-left my-3"}>8. Transaksi berhasil.</p>
						</div>
					}
					actClose={() => this.setState({ show: false })}
				/>
			</div>
		);
	}
}
const mapStateToProps = (state) => {
	return {
		loanDetail: state.loanDetailState,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getLoanDetail: (ClientID, loanCode) => {
			dispatch(LoanDetail(ClientID, loanCode));
		},
		SetError: (errMsg) => {
			dispatch({ type: SET_ERROR_STATE, payload: errMsg });
		},
	};
};
// export default StatusPinjamanDetil;
export default CheckAuth(connect(mapStateToProps, mapDispatchToProps)(StatusPinjamanDetil));
